package br.com.texeratx.boardgametimeapp.data.model.player

import kotlinx.serialization.Serializable

@Serializable
data class UpdatePlayerRequest(
    val name: String,
    val nickname: String?,
    val imageUrl: String?,
    val birthday: String?,
    val phone: String?
)
